import styled from 'styled-components';
import {
  Form,
} from 'antd';
import { COLOR_LINK, COLOR_WHITE } from 'constants/colors';

export const MainContainer = styled(Form)`
  display: flex;
  padding: 1.5rem;
  background-color: ${COLOR_WHITE};

  & > * {
    flex: 1;
  } 
`;

export const DetailsButton = styled.button`
  background: transparent;
  font-size: 0.875rem;
  color: ${COLOR_LINK};
  outline: none;
  border: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;
